import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './styles.css'
import App from './App.vue'
import { router } from './router'
import { initAuth } from './lib/auth'

// Auth is initialised before mount so the redirect leg from Entra completes before
// any route guard runs. Mounting first produces a visible flash of the signed-out
// shell on every return from login.
initAuth()
  .catch((err) => console.error('auth init failed', err))
  .finally(() => {
    createApp(App).use(createPinia()).use(router).mount('#app')
  })
